import React, { Component } from 'react';
import { Grid, Row, Col, Link } from 'react-bootstrap';

// Sample code , how to implement: https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_modal

export default class Modal extends Component {
  componentDidMount() {
    // The following will prevent page scrolling when a modal is open.
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
  }

  render() {
    return <div className="modalContainer">{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/Modal/Modal.js